import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: '',
        userInfo: {},
        signedDateList: [],
        userRegisteredGamesList:[],
        isHermsLogin: false,
        isLoginInM: false,
        isNavMask: false,
        isMaskScreenTips: false,
        isHmsLogin: false,
        isLoadingAll: false,
        isMaskAll: false,
        footerId: 0,
        tabId: 0,
        showLogin: true,
        isShowLogin: true,
        isLoginStore: false,
        isLoginCustomer: false,
        isShowHomeLatestGame:false
    },
    mutations: {
        setIsShowHomeLatestGame(state, data) {
            state.isShowHomeLatestGame = data;
        },
        setToken(state, token) {
            state.token = token;
        },
        setUserInfo(state, data) {
            state.userInfo = data;
        },
        setuserRegisteredGamesList(state, data) {
            state.userRegisteredGamesList = data;
        },
        setSignDate(state, data) {
            state.signedDateList = data;
        },
        setIsHermsLogin(state, data) {
            state.isHermsLogin = data;
        },
        setIsLoginIn(state, data) {
            state.isLoginInM = data;
        },
        setIsNavMask(state, data) {
            state.isNavMask = data;
        },
        setIsMaskScreenTips(state, data) {
            state.isMaskScreenTips = data;
        },
        setIsHmsLogin(state, data) {
            state.isHmsLogin = data;
        },
        setIsLoadingAll(state, data) {
            state.isLoadingAll = data;
        },
        setIsMaskAll(state, data) {
            state.isMaskAll = data;
        },
        setFooterId(state, data) {
            state.footerId = data;
        },
        setTabId(state, data) {
            state.tabId = data;
        },
        setIsLogin(state, data) {
            state.isShowLogin = data;
        },
        setIsLoginStore(state, data) {
            state.isLoginStore = data;
        },
        setIsLoginCustomer(state, data) {
            state.isLoginCustomer = data;
        },
        showLogin(state, data) {
            state.showLogin = data;
        }
    },
    actions: {},
    modules: {}
})